import Vue from 'vue'
import Router from 'vue-router'
import AuthRequired from '@/utils/AuthRequired'
import { OmsGuard, OMS_ROLE, omsRedirectFor } from '@/website/backend/oms/oms_auth'
import { getOmsContext, isOmsStatusKnown } from '@/website/backend/oms/oms_service'

Vue.use(Router)

const routes = [
    {
        path: '/order',
        component: () => import(/* webpackChunkName: "backend" */ '@/website/backend'),
        redirect: '/order',
        beforeEnter: AuthRequired,
        children: [
        
            {
                path: '/add-order', component: () => import(/* webpackChunkName: "add-order" */ '@/website/backend/add_order'),
                meta: { title: 'เพิ่มออเดอร์ใหม่' }
            },
            {
                path: '/inbox', component: () => import(/* webpackChunkName: "add-order" */ '@/website/backend/manage_customer/chat-unified.vue'),
                meta: { title: 'กล่องข้อความ' }
            },
            {
                path: '/pos', component: () => import(/* webpackChunkName: "pos" */ '@/website/backend/pos/index.vue'),
                meta: { title: 'ขายหน้าร้าน (POS)' }
            },
            {
                path: '/chat-unified', name: 'chatUnified',
                component: () => import(/* webpackChunkName: "chat-unified" */ '@/website/backend/manage_customer/chat-unified.vue'),
                meta: { title: 'กล่องข้อความ (ใหม่)' }
            },
            {
                path: '/import-order-by-excel', component: () => import(/* webpackChunkName: "add-order" */ '@/website/backend/add_order/add_order_excel'),
                meta: { title: 'นำเข้าออเดอร์จาก Excel' }
            },
            {
                path: '/add-order-success', component: () => import(/* webpackChunkName: "add-order-success" */ '@/website/backend/add_order/add_order_success'),
                meta: { title: 'เพิ่มออเดอร์สำเร็จ' }
            },
            {
                path: '/order', component: () => import(/* webpackChunkName: "order" */ '@/website/backend/order'),
                meta: { title: 'ออเดอร์ของฉัน' }
            },
            {
                path: '/refund-list', component: () => import(/* webpackChunkName: "order" */ '@/website/backend/order/refund-list'),
                meta: { title: 'รายการคืนเงิน/คืนสินค้า' }
            },
            {
                path: '/order-B2B', component: () => import(/* webpackChunkName: "report-detail-order" */ '@/website/backend/order/order_b2b.vue'),
                meta: { title: 'ออเดอร์ B2B' }
            },
            
            {
                path: '/product-pack-list', component: () => import(/* webpackChunkName: "order" */ '@/website/backend/order/order_and_Delivery_Tracking'),
                meta: { title: 'จัดส่งพัสดุ' }
            },
            {
                path: '/order-detail', component: () => import(/* webpackChunkName: "order" */ '@/website/backend/order/order_detail.vue'),
                meta: { title: 'OrderDetail' }
            },
            {
                path: '/order-detail-archive', component: () => import(/* webpackChunkName: "order" */ '@/website/backend/order/order_detail_archive.vue'),
                meta: { title: 'OrderDetailArchive' }
            },
            {
                path: '/profit-detail', component: () => import(/* webpackChunkName: "order" */ '@/website/backend/report/report_profit_detail.vue'),
                meta: { title: 'OrderDetail' }
            },
            {
                path: '/mhao-order-item', component: () => import(/* webpackChunkName: "order" */ '@/website/backend/order/mhao_order_item.vue'),
                meta: { title: 'ตรวจสอบสินค้าเหมาๆ' }
            },
            {
                path: '/deliveryprice', component: () => import('@/website/backend/deliveryprice'),
                meta: { title: 'ค่าขนส่ง' }
            },
            {
                path: '/mhao-chaina-order', component: () => import(/* webpackChunkName: "order" */ '@/website/backend/order/mhao_chaina_order.vue'),
                meta: { title: 'รายการสั่งซื้อสินค้า' }
            },
            {
                path: '/mhao-chaina-check-order', component: () => import(/* webpackChunkName: "order" */ '@/website/backend/order/mhao_chaina_check_order.vue'),
                meta: { title: 'รายการสั่งซื้อสินค้า' }
            },
            {
                path: '/stock-history/:product_name', component: () => import(/* webpackChunkName: "stock-history" */ '@/website/backend/stock_history'),
                meta: { title: 'Stock History' }
            },
            {
                path: '/stock-history', component: () => import(/* webpackChunkName: "stock-history" */ '@/website/backend/stock_history/stock_history.vue'),
                meta: { title: 'Stock History' }
            },
            {
                path: '/my-product', component: () => import(/* webpackChunkName: "stock-history" */ '@/website/backend/stock_new'),
                meta: { title: 'สินค้าของฉัน' }
            },
            {
                path: '/my-stock', component: () => import(/* webpackChunkName: "stock-history" */ '@/website/backend/stock_new/allstock'),
                meta: { title: 'สต๊อกสินค้า' }
            },
            {
                path: '/update/excel', component: () => import(/* webpackChunkName: "stock-history" */ '@/website/backend/stock_new/addstock_excel'),
                meta: { title: 'เพิ่มสินค้า excel' }
            },
            {
                path: '/stock-info', component: () => import(/* webpackChunkName: "stock-history" */ '@/website/backend/stock_new/stock-info'),
                meta: { title: 'Stock' }
            },
            {
                path: '/stock-report', component: () => import(/* webpackChunkName: "stock-history" */ '@/website/backend/stock_new/allstock-info'),
                meta: { title: 'ภาพรวมการเดินสต๊อก' }
            },
            {
                path: '/stock-check-report', component: () => import(/* webpackChunkName: "stock-history" */ '@/website/backend/stock_new/stock-report'),
                meta: { title: 'รายงานการเช็คสต๊อก' }
            },
            {
                path: '/my-product/update', component: () => import(/* webpackChunkName: "add-stock" */ '@/website/backend/stock_new/addstock'),
                meta: { title: 'อัพเดทสินค้า' }
            },
            {
                path: '/transfer-list/update', component: () => import(/* webpackChunkName: "add-stock" */ '@/website/backend/stock_new/import'),
                meta: { title: '' }
            },
            {
                path: '/transfer-list', component: () => import(/* webpackChunkName: "add-stock" */ '@/website/backend/stock_new/import_master'),
                meta: { title: 'นำเข้า/นำออก/โอนย้ายสินค้า' }
            },
            {
                path: '/codreport', component: () => import(/* webpackChunkName: "report" */ '@/website/backend/report/codreport'),
                meta: { title: 'รายงาน COD' }
            },
            {
                path: '/report-sales', component: () => import(/* webpackChunkName: "report-detail-order" */ '@/website/backend/report/report_sales'),
                meta: { title: 'รายงานยอดขายสินค้า' }
            },
            {
                path: '/report-profit', component: () => import(/* webpackChunkName: "report-detail-order" */ '@/website/backend/report/report_profit'),
                meta: { title: 'รายงานสรุปกำไรขาดทุน' }
            },
            {
                path: '/report-space', component: () => import(/* webpackChunkName: "report-detail-order" */ '@/website/backend/report/report_space'),
                meta: { title: 'รายงานการใช้พื้นที่' }
            },
            {
                path: '/report-sales1', component: () => import(/* webpackChunkName: "report-detail-order" */ '@/website/backend/report/report_sales_card1'),
                meta: { title: 'รายงานยอดขายสินค้าทั้งหมด' }
            },
            {
                path: '/report-sales2', component: () => import(/* webpackChunkName: "report-detail-order" */ '@/website/backend/report/report_sales_card2'),
                meta: { title: 'Report' }
            },
            {
                path: '/report-purchase', component: () => import(/* webpackChunkName: "report-detail-order" */ '@/website/backend/report/report_purchase'),
                meta: { title: 'รายงานการสินค้าเพื่อจัดส่ง' }
            },
            // {
            //     path: '/manageuser', component: () => import(/* webpackChunkName: "staff_manage" */ '@/website/backend/manageUser/'),
            //     meta: { title: 'จัดการผู้ใช้' }
            // },
            {
                path: '/manageuser', component: () => import(/* webpackChunkName: "staff_manage" */ '@/website/backend/manageUser/index_Renew'),
                meta: { title: 'จัดการผู้ใช้' }
            },
            {
                path: '/manageuserNew', component: () => import(/* webpackChunkName: "staff_manage" */ '@/website/backend/manageUser/index_Renew'),
                meta: { title: 'จัดการผู้ใช้' }
            },
            {
                path: '/calculate-salary', component: () => import(/* webpackChunkName: "staff_manage" */ '@/website/backend/manageUser/calculate-salary'),
                meta: { title: 'คำนวณเงินเดือน' }
            },
            {
                path: '/wallet', component: () => import(/* webpackChunkName: "finance" */ '@/website/backend/finance/'),
                meta: { title: 'wallet ของฉัน' }
            },
            {
                path: '/notify_transfer', component: () => import(/* webpackChunkName: "finance" */ '@/website/backend/finance/notify_transfer'),
                meta: { title: 'แจ้งชำระเงิน' }
            },
            {
                path: '/notify_withdraw', component: () => import(/* webpackChunkName: "withdraw" */ '@/website/backend/withdraw'),
                meta: { title: 'แจ้งถอนเงิน' }
            },
            {
                path: '/view_detail_invoice', component: () => import(/* webpackChunkName: "finance" */ '@/website/backend/finance/view_detail_invoice'),
                meta: { title: 'view_detail_invoice' }
            },
            {
                path: '/invoice-group', component: () => import(/* webpackChunkName: "finance" */ '@/website/backend/finance/invoiceGroup'),
                meta: { title: 'รายการใบแจ้งหนี้ที่จัดกลุ่ม' }
            },

            {
                path: '/shop-setting', component: () => import(/* webpackChunkName: "finance" */ '@/website/backend/setting'),
                meta: { title: 'ตั้งค่าข้อมูลร้าน' }
            },
            {
                path: '/dashboard', component: () => import(/* webpackChunkName: "finance" */ '@/website/backend/dashboard'),
                meta: { title: 'Dashboard' }
            },
            {
                path: '/dashboard_admin_sale', component: () => import(/* webpackChunkName: "finance" */ '@/website/backend/dashboard/dashboard_admin_sale'),
                meta: { title: 'ยอดขายตามแอดมิน' }
            },
            {
                path: '/dashboard_best_sale_product', component: () => import(/* webpackChunkName: "finance" */ '@/website/backend/dashboard/dashboard_best_sale_product'),
                meta: { title: 'สินค้าขายดี' }
            },
            {
                path: '/ts', component: () => import(/* webpackChunkName: "finance" */ '@/website/backend/ts/'),
                meta: { title: 'Ts' }
            },
            {
                path: '/promotion', component: () => import(/* webpackChunkName: "finance" */ '@/website/backend/promotion'),
                meta: { title: 'โปรโมชั่นสินค้า' }
            },
            {
                path: '/promotion/update', component: () => import(/* webpackChunkName: "finance" */ '@/website/backend/promotion/add_promotion'),
                meta: { title: 'เพิ่มโปรโมชั่น' }
            },
            {
                path: '/warehouse', component: () => import(/* webpackChunkName: "manage-warehouse" */ '@/website/backend/warehouse'),
                meta: { title: 'จัดการคลังสินค้า' }
            },
            {
                path: '/connect', component: () => import(/* webpackChunkName: "manage-warehouse" */ '@/website/backend/connect'),
                meta: { title: 'เชื่อมต่อ' }
            },
            {
                path: '/category-setting', component: () => import(/* webpackChunkName: "manage-catagories" */ '@/website/backend/manage_category'),
                meta: { title: 'จัดการหมวดหมู่' }
            },
            {
                path: '/cod-wallet', component: () => import(/* webpackChunkName: "finance" */ '@/website/backend/cod_wallet/'),
                meta: { title: 'cod wallet ของฉัน' }
            },
            {
                path: '/view-detail-cod-wallet', component: () => import(/* webpackChunkName: "finance" */ '@/website/backend/cod_wallet/view_detail_cod_wallet.vue'),
                meta: { title: 'รายละเอียด cod wallet' }
            },
            {
                path: '/packing', component: () => import(/* webpackChunkName: "packing" */ '@/website/backend/china_packing'),
                meta: { title: 'packing' }
            },
            {
                path: '/history-tax-invoice', component: () => import(/* webpackChunkName: "packing" */ '@/website/backend/invoice'),
                meta: { title: 'ประวัติจัดเก็บ invoice' }
            },
            {
                path: '/manage-customer', component: () => import(/* webpackChunkName: "packing" */ '@/website/backend/manage_customer/manage_customer.vue'),
                meta: { title: 'ลูกค้า' }
            },
            {
                path: '/manage-partner', component: () => import(/* webpackChunkName: "packing" */ '@/website/backend/manage_partner/manage_partner.vue'),
                meta: { title: 'คู่ค้า' }
            },
            {
                path: '/purchase', component: () => import(/* webpackChunkName: "order" */ '@/website/backend/finance/purchase'),
                meta: { title: 'รายการซื้อ' }
            },
            {
                path: '/addpurchase', component: () => import(/* webpackChunkName: "order" */ '@/website/backend/finance/addExpense'),
                meta: { title: 'เพิ่มรายการซื้อ' }
            },
            {
                path: '/manage-partner-detail', component: () => import(/* webpackChunkName: "packing" */ '@/website/backend/manage_partner/manage_partner_detail.vue'),
                meta: { title: 'คู่ค้า' }
            },
            {
                path: '/chat', component: () => import(/* webpackChunkName: "packing" */ '@/website/backend/manage_customer/chat.vue'),
                meta: { title: 'ลูกค้า' }
            },
            {
                path: '/chat-new', component: () => import(/* webpackChunkName: "packing" */ '@/website/backend/manage_customer/chat-new.vue'),
                meta: { title: 'แชท' }
            },
            {
                path: '/shop-agent', component: () => import(/* webpackChunkName: "packing" */ '@/website/backend/shop_agent'),
                meta: { title: 'ตัวแทน' }
            },
            {
                path: '/consider_transfer_master', component: () => import(/* webpackChunkName: "finance" */ '@/website/backend/finance/agent/consider_transfer_master'),
                meta: { title: 'รายการตัวแทนแจ้งโอนเงิน' }
            },
            {
                path: '/wallet_master', component: () => import(/* webpackChunkName: "finance" */ '@/website/backend/finance/agent/wallet_master'),
                meta: { title: 'รายการ balance' }
            },
            {
                path: '/notify_transfer_agent', component: () => import(/* webpackChunkName: "finance" */ '@/website/backend/finance/agent/notify_transfer_agent'),
                meta: { title: 'แจ้งชำระเงิน' }
            },
            {
                path: '/wallet_agent', component: () => import(/* webpackChunkName: "finance" */ '@/website/backend/finance/agent/wallet_agent'),
                meta: { title: 'รายการ balance' }
            },{
                path: '/feedback', component: () => import(/* webpackChunkName: "finance" */ '@/website/backend/feedback'),
                meta: { title: 'ข้อเสนอแนะ' }
            },
            {
                path: '/teach', component: () => import(/* webpackChunkName: "report" */ '@/website/backend/teachuser'),
                meta: { title: 'ตั้งค่าการใช้งาน' }
            },
            {
                path: '/package', component: () => import(/* webpackChunkName: "report" */ '@/website/backend/package'),
                meta: { title: 'แพ็กเกจ' }
            },
            {
                path: '/expense', component: () => import(/* webpackChunkName: "order" */ '@/website/backend/finance/expense'),
                meta: { title: 'ค่าใช้จ่าย' }
            },
            {
                path: '/addexpense', component: () => import(/* webpackChunkName: "order" */ '@/website/backend/finance/addExpense'),
                meta: { title: 'เพิ่มค่าใช้จ่าย' }
            },
            {
                path: '/expense-payment-report', component: () => import(/* webpackChunkName: "order" */ '@/website/backend/finance/ExpensePaymentReport'),
                meta: { title: 'รายการจ่ายเงิน' }
            },
            {
                path: '/order-payment-report', component: () => import(/* webpackChunkName: "order" */ '@/website/backend/finance/OrderPaymentReport'),
                meta: { title: 'รายการรับเงิน' }
            },
            {
                path: '/cash-flow', component: () => import(/* webpackChunkName: "order" */ '@/website/backend/finance/CashFlowReport'),
                meta: { title: 'กระแสเงินสด' }
            },
            {
                path: '/lot-stock', component: () => import(/* webpackChunkName: "order" */ '@/website/backend/stock_new/lot_stock'),
                meta: { title: 'ล็อตสินค้า' }
            },
            {
                path: '/stock-planing', component: () => import(/* webpackChunkName: "order" */ '@/website/backend/stock_new/stock_planing'),
                meta: { title: 'แผนการจัดส่ง' }
            },
            {
                path: '/crm-reorder', component: () => import(/* webpackChunkName: "order" */ '@/website/backend/crm/reorder_reminder.vue'),
                meta: { title: 'ติดตามการขาย' }
            },
            {
                path: '/manage-customer-detail', component: () => import(/* webpackChunkName: "packing" */ '@/website/backend/manage_customer/manage_customer_detail.vue'),
                meta: { title: 'ลูกค้า' }
            },

            //
            {
                path: '/order-and-delivery-tracking', component: () => import(/* webpackChunkName: "packing" */ '@/website/backend/order/order_and_Delivery_Tracking.vue'),
                meta: { title: 'ออเดอร์ และเลขแทรค' }
            },
            {
                path: '/product-boost', component: () => import(/* webpackChunkName: "stock-history" */ '@/website/backend/product/boots_item_shopee'),
                meta: { title: 'โปรโมทสินค้า' }
            },
            {
                path: '/ticket', component: () => import('@/website/backend/ticket/ticket.vue'),
                meta: { title: 'ticket' }
            },
            {
                path: '/ticket-detail', component: () => import('@/website/backend/ticket/ticket-detail.vue'),
                meta: { title: 'รายละเอียด ticket' }
            },

            // OMS (เฉพาะ shop ที่มีผู้ใช้ OMS)
            {
                path: '/oms/order', component: () => import(/* webpackChunkName: "oms" */ '@/website/backend/oms/order.vue'),
                beforeEnter: OmsGuard([OMS_ROLE.ADMIN, OMS_ROLE.CREATOR, OMS_ROLE.APPROVER]),
                meta: { title: 'รายการคำสั่งซื้อ OMS' }
            },
            {
                path: '/oms/order-detail', component: () => import(/* webpackChunkName: "oms" */ '@/website/backend/oms/order_detail.vue'),
                beforeEnter: OmsGuard([OMS_ROLE.ADMIN, OMS_ROLE.CREATOR, OMS_ROLE.APPROVER]),
                meta: { title: 'รายละเอียดคำสั่งซื้อ OMS' }
            },
            {
                path: '/oms/add-order', component: () => import(/* webpackChunkName: "oms" */ '@/website/backend/oms/add_order.vue'),
                beforeEnter: OmsGuard([OMS_ROLE.ADMIN, OMS_ROLE.CREATOR]),
                meta: { title: 'สร้างคำสั่งซื้อ OMS' }
            },
            {
                path: '/oms/location', component: () => import(/* webpackChunkName: "oms" */ '@/website/backend/oms/location.vue'),
                beforeEnter: OmsGuard([OMS_ROLE.ADMIN]),
                meta: { title: 'Stock Location' }
            },
            {
                path: '/oms/quota', component: () => import(/* webpackChunkName: "oms" */ '@/website/backend/oms/quota.vue'),
                beforeEnter: OmsGuard([OMS_ROLE.ADMIN]),
                meta: { title: 'จัดสรรโควตา' }
            },
            {
                path: '/oms/store', component: () => import(/* webpackChunkName: "oms" */ '@/website/backend/oms/store.vue'),
                beforeEnter: OmsGuard([OMS_ROLE.ADMIN]),
                meta: { title: 'ร้านค้า OMS' }
            },
            {
                path: '/oms/stock', component: () => import(/* webpackChunkName: "oms" */ '@/website/backend/oms/stock.vue'),
                beforeEnter: OmsGuard([OMS_ROLE.ADMIN, OMS_ROLE.CREATOR, OMS_ROLE.APPROVER]),
                meta: { title: 'สต๊อก OMS' }
            },
            {
                path: '/oms/user', component: () => import(/* webpackChunkName: "oms" */ '@/website/backend/oms/user.vue'),
                beforeEnter: OmsGuard([OMS_ROLE.ADMIN, OMS_ROLE.CREATOR, OMS_ROLE.APPROVER]),
                meta: { title: 'ผู้ใช้' }
            },

        ]
    },
    {
        path: '/error', component: () => import(/* webpackChunkName: "error" */ '@/website/Error'),
        meta: { title: 'Error' }
    },
    {
        path: '*', component: () => import(/* webpackChunkName: "error" */ '@/website/Login'),
        meta: { title: 'Login: Fulfillment เก็บ แพ็ค ส่ง' }
    },
    {
      path: '/purchase-order', component: () => import(/* webpackChunkName: "purchase-order" */ '@/website/backend/purchase_order'),
        meta: { title: 'Login: Fulfillment เก็บ แพ็ค ส่ง ' }
    },
     {
        path: '/login', component: () => import(/* webpackChunkName: "login" */ '@/website/Login'),
        meta: { title: 'Login: Fulfillment เก็บ แพ็ค ส่ง ' }
    },
    {
        path: '/login2', component: () => import(/* webpackChunkName: "login" */ '@/website/Login2'),
        meta: { title: 'Login: Fulfillment เก็บ แพ็ค ส่ง ' }
    },
    {
        path: '/LoginOasys', component: () => import(/* webpackChunkName: "login" */ '@/website/backend/oasysRegister/LoginOasys'),
        meta: { title: 'Login: Oasys ' }
    },
    {
        path: '/auth/register', component: () => import(/* webpackChunkName: "login" */ '@/website/backend/oasysRegister/RegisterOasys'),
        meta: { title: 'สมัครสมาชิก ' }
    },
    {
        path: '/auth/facebook/register', component: () => import(/* webpackChunkName: "login" */ '@/website/backend/oasysRegister/RegisterFacebookOasys'),
        meta: { title: 'สมัครสมาชิก ' }
    },
    {
        path: '/auth/confirm-sign-up', component: () => import(/* webpackChunkName: "login" */ '@/website/backend/oasysRegister/confirmEmail'),
        meta: { title: 'สมัครสมาชิก ' }
    },
    {
        path: '/auth/forgot-password', component: () => import(/* webpackChunkName: "login" */ '@/website/backend/oasysRegister/forgotPassword'),
        meta: { title: 'ลืมรหัสผ่าน ' }
    },
    {
        path: '/auth/reset-password', component: () => import(/* webpackChunkName: "login" */ '@/website/backend/oasysRegister/resetPassword'),
        meta: { title: 'เปลี่ยนรหัสผ่าน ' }
    },
    {
        path: '/ss/login', component: () => import(/* webpackChunkName: "login" */ '@/website/Agent_Login'),
        meta: { title: 'Login: SATISFY SOLUTION ซื้อง่าย ขายได้จริง ' }
    },
    {
        path: '/print', component: () => import(/* webpackChunkName: "login" */ '@/website/backend/order/print.vue'),
        meta: { title: 'Print' }
    },
    {
        path: '/register', component: () => import(/* webpackChunkName: "register" */ '@/website/Register'),
        meta: { title: 'สมัครสมาชิก' }
    },
    {
        path: '/ss/register', component: () => import(/* webpackChunkName: "register" */ '@/website/Agent_Register'),
        meta: { title: 'สมัครสมาชิก' }
    },
    {
        path: '/thankyou', component: () => import(/* webpackChunkName: "register" */ '@/website/backend/register/register_success'),
        meta: { title: 'Thankyou' }
    },
    {
        path: '/ss/thankyou', component: () => import(/* webpackChunkName: "register" */ '@/website/backend/register/agent_success'),
        meta: { title: 'Thankyou' }
    },
    {
        path: '/print-invoice', component: () => import(/* webpackChunkName: "login" */ '@/website/backend/finance/printNew.vue'),
        meta: { title: 'ปริ้นใบแจ้งหนี้' }
    },
    {
        path: '/print-tax-invoice', component: () => import(/* webpackChunkName: "login" */ '@/website/backend/order/print_tax_invoice.vue'),
        meta: { title: 'ปริ้นใบแจ้งหนี้' }
    },
    {
        path: '/print-cover-pages', component: () => import(/* webpackChunkName: "login" */ '@/website/backend/order/print_cover_pages.vue'),
        meta: { title: 'ปริ้นใบปะหน้า' }
    },
    {
        path: '/printPackingList', component: () => import('@/website/backend/order/printPackingList'),
        meta: { title: 'พิมพ์ใบ PackingList' }
    },
    {    
        path: '/printAws', component: () => import('@/website/backend/order/printAws'),
        meta: { title: 'พิมพ์ใบ Aws' }
    },
    {
        path: '/pos-receipt', component: () => import(/* webpackChunkName: "pos" */ '@/website/backend/pos/print_receipt.vue'),
        meta: { title: 'ใบเสร็จ POS' }
    },
    {
        path: '/shopee/callback', component: () => import(/* webpackChunkName: "login" */ '@/website/backend/callback/shopee.vue'),
        meta: { title: 'callback' }
    },
    {
        path: '/shopee/chat/callback', component: () => import(/* webpackChunkName: "login" */ '@/website/backend/callback/shopeechat.vue'),
        meta: { title: 'callback' }
    },
    {
        path: '/lazada/chat/callback', component: () => import(/* webpackChunkName: "login" */ '@/website/backend/callback/lazadachat.vue'),
        meta: { title: 'callback' }
    },
    {
        path: '/lazada/callback', component: () => import(/* webpackChunkName: "login" */ '@/website/backend/callback/lazada.vue'),
        meta: { title: 'callback' }
    },
    {
        path: '/jd/callback', component: () => import(/* webpackChunkName: "login" */ '@/website/backend/callback/jd.vue'),
        meta: { title: 'callback' }
    },
    {
        path: '/line/callback', component: () => import(/* webpackChunkName: "login" */ '@/website/backend/callback/line_notify.vue'),
        meta: { title: 'callback' }
    },
    {
        path: '/tiktok/callback', component: () => import(/* webpackChunkName: "login" */ '@/website/backend/callback/tiktok.vue'),
        meta: { title: 'callback' }
    },
    {
        path: '/facebook/callback', component: () => import(/* webpackChunkName: "login" */ '@/website/backend/callback/facebook_page.vue'),
        meta: { title: 'callback' }
    },
]

const router = new Router({
    routes,
    mode: 'history',
    linkActiveClass: 'active'
})
router.beforeEach(async (to, from, next) => {
    // เพิ่ง login และยังไม่รู้ว่าเป็นผู้ใช้ OMS หรือไม่: รอผลหนึ่งครั้งก่อนเปิดหน้าหลังบ้าน
    // ไม่อย่างนั้นผู้ใช้ OMS จะเห็นหน้าและเมนูเดิมแวบหนึ่งก่อนถูกพาไปหน้า OMS
    if (!isOmsStatusKnown() && to.matched.length > 0 && to.matched[0].path === routes[0].path) {
        await getOmsContext();
    }
    // ผู้ใช้ OMS เปิดได้เฉพาะหน้าในเมนูของตน (ผู้ใช้ทั่วไปได้ null เสมอ)
    const omsRedirect = omsRedirectFor(to, routes[0].path)
    if (omsRedirect != null) {
        next(omsRedirect);
        return;
    }
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
});

export default router
